import { render } from "./nextTripSlide.vue?vue&type=template&id=06c5e8f2"
import script from "./nextTripSlide.vue?vue&type=script&lang=js"
export * from "./nextTripSlide.vue?vue&type=script&lang=js"

import "./nextTripSlide.vue?vue&type=style&index=0&id=06c5e8f2&lang=css"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__